// extracted by mini-css-extract-plugin
module.exports = {"notice":"dmbc-store_notice-notice","label":"dmbc-store_notice-label","icon":"dmbc-store_notice-icon","divider":"dmbc-store_notice-divider","value":"dmbc-store_notice-value"};